import {getTime} from './dateService';

const formatNum = ({
  value,
  decimals,
  multiplier,
  unit,
}: {
  value: unknown;
  decimals?: number;
  multiplier?: number;
  unit?: string;
}): string => {
  if (value == null) return '-';
  return `${(Number(value) * (multiplier ?? 1)).toFixed(decimals ?? 1)}${unit ?? ''}`;
};

const formatTime = (value: number | null | undefined): string => {
  return getTime(value ?? undefined) ?? '-';
};

export {formatNum, formatTime};
